export enum PlayerUsernameSelectionPageErrors {
  UsernameInUse = 'UsernameInUse',
  SessionBlocked = 'SessionBlocked',
}
